import React, {Component, Fragment} from "react";
import {CommandBarButton, Toggle} from "office-ui-fabric-react";
import {
    DurableFunctionInstance,
} from "../../../models/DurableFunctionInstance";
import PageTitle from "../../PageTitle";
import {ICDBPageProps } from "../../../utils/ICDBPageProps";
import {BulkItemInstance, parseBulkItemInstance} from "./BulkItemInstance";
import BulkProcessorItemTable from "./BulkProcessorItemTable";
import LoadingPage from "../../LoadingPage";
import ComparisonBreakdown from "../../../models/mailroom/comparison/ComparisonBreakdown";
import _ from "lodash";
import ComparisonBreakdownCharts from "../comparison/ComparisonBreakdownCharts";


interface MailroomBulkComparisonInstancePageProps extends ICDBPageProps
{
    instanceId: string;
}

interface MailroomBulkComparisonInstancePageState {
    instance?: DurableFunctionInstance;
    childItems?: BulkItemInstance[];
    showCharts: boolean;
    showZeros: boolean;
    loading: boolean;
}


export default class MailroomBulkComparisonInstancePage extends Component<MailroomBulkComparisonInstancePageProps, MailroomBulkComparisonInstancePageState> {
    
    
    
    constructor(props: MailroomBulkComparisonInstancePageProps) {
        super(props);

        this.state = {
            instance: undefined,
            showCharts: false,
            showZeros: true,
            loading: false
        };
    }

    public async componentDidMount()
    {
        await this.getInstanceAndOutput();
    }

    async componentDidUpdate(prevProps: Readonly<MailroomBulkComparisonInstancePageProps>, prevState: Readonly<MailroomBulkComparisonInstancePageState>, snapshot?: any): Promise<void> {
    }

    private async getInstanceAndOutput() {

        this.setState({
            loading: true
        });

        try {

            const instance = await this.props.apiService.getMailroomFunctionInstance(this.props.instanceId);
            let childInstances = await this.props.apiService.getMailroomBulkProcessorComparisonItems(this.props.instanceId);
            
            
            this.setState({
                instance: instance,
                childItems: childInstances.map(ci => parseBulkItemInstance(ci)),
                loading: false
            });

        }
        catch (e) {
            console.log(e);
            this.props.messageBar.error(`Failed to get bulk comparison instance (${this.props.instanceId}) : ${e}`);
            this.setState({
                loading: false
            })
        }
    }
    
    
    private renderCharts(): JSX.Element | null
    {
        if(!this.state.showCharts || !this.state.childItems)
        {
            return null;
        }
        
        
        const completedItems = this.state.childItems.filter(x => x.runtimeStatus === "Completed")
        const breakdowns = completedItems.map(x => x.ParsedOutput?.comparisonSummary?.breakdown).filter(b => !!b);
        
        if(breakdowns.length === 0)
        {
            return null;
        }
        
        const combined: ComparisonBreakdown = {byProcessorItemType: {}}
        for(const processorItemType of _.keys(breakdowns[0].byProcessorItemType))
        {
            const counts = breakdowns.map(b => b.byProcessorItemType[processorItemType]);
            
            combined.byProcessorItemType[processorItemType] = {
                addedCount: _.sumBy(counts, c => c.addedCount),
                changedCount: _.sumBy(counts, c => c.changedCount),
                removedCount: _.sumBy(counts, c => c.removedCount),
                total: _.sumBy(counts, c => c.total),
            }
        }
        
        return (
            <ComparisonBreakdownCharts breakdown={combined} onCloseClicked={() => this.setState({showCharts: false})}/>
        );
        
    }

    public render()
    {
        
        if(this.state.loading)
        {
            return <LoadingPage/>;
        }
        
        let itemsToShow = this.state.childItems || [];
        itemsToShow = itemsToShow.filter(i =>
        {
            if(this.state.showZeros === false && i.ParsedOutput.comparisonSummary.total === 0)
            {
                return false;
            }
            
            return true;
        });
        
        return (
            <Fragment>
                <PageTitle title="Bulk Comparison" />
                {this.renderCharts()}
                
                <BulkProcessorItemTable bulkInstanceId={this.props.instanceId} items={itemsToShow}>

                    <CommandBarButton
                        iconProps={{ iconName: "DonutChart" }}
                        text="Chart Results"
                        onClick={() => {
                            this.setState({
                                showCharts: true
                            });
                        }}
                    />
                    
                    <Toggle
                        label={"Show zeros"}
                        inlineLabel={true}
                        checked={this.state.showZeros}
                        onChange={(event, newValue) => {
                            this.setState({
                                showZeros: newValue!
                            });
                        }}
                        role="switch"
                    />
                </BulkProcessorItemTable>
            </Fragment>
        );
    }
}